import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { MessageEvent } from './message_events';

@Injectable({ providedIn: 'root' })
export class MessageEventProvider extends DomainEventProvider<MessageEvent> {}
